import script from "./TressCloseButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressCloseButton.vue?vue&type=script&lang=ts&setup=true"

import "./TressCloseButton.vue?vue&type=style&index=0&id=764230e2&lang=scss"

const __exports__ = script;

export default __exports__